import { render, staticRenderFns } from "./groupPatientsIndex.vue?vue&type=template&id=886c8cda&scoped=true"
import script from "./groupPatientsIndex.vue?vue&type=script&lang=js"
export * from "./groupPatientsIndex.vue?vue&type=script&lang=js"
import style0 from "./groupPatientsIndex.vue?vue&type=style&index=0&id=886c8cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886c8cda",
  null
  
)

export default component.exports